export default __webpack_public_path__ + "static/media/icon-algocare-n@3x.4f148168.webp";